import React from 'react';
import { StarIcon } from 'lucide-react';
export const TestimonialsSection: React.FC = () => {
  const testimonials = [{
    name: 'Carlos Méndez',
    age: 34,
    city: 'Buenos Aires, Argentina',
    text: 'Antes perdía horas armando entrenamientos. Ahora tengo todo listo en 10 minutos. Mis jugadores mejoraron un montón y yo recuperé mi vida.'
  }, {
    name: 'Diego Fernández',
    age: 41,
    city: 'Rosario, Argentina',
    text: 'Las tácticas reales son oro puro. Las apliqué en mi equipo y ganamos 5 partidos seguidos. Mis jugadores entienden perfectamente qué hacer.'
  }, {
    name: 'Lucas Sánchez',
    age: 37,
    city: 'Mendoza, Argentina',
    text: 'Compré el pack completo y no me arrepiento. Cada bono vale más de lo que pagué por todo. Recomendado 100%.'
  }];
  return <section className="py-14 px-4 bg-gray-50" data-id="element-279">
      <div className="max-w-6xl mx-auto" data-id="element-280">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10" data-id="element-281">
          Lo que dicen otros entrenadores
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-282">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-283">
              <div className="flex gap-1 mb-4" data-id="element-284">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-yellow-400 fill-current" data-id="element-285" />)}
              </div>

              <p className="text-gray-700 italic mb-4 leading-relaxed" data-id="element-286">
                "{testimonial.text}"
              </p>

              <div className="border-t border-gray-100 pt-4" data-id="element-287">
                <p className="font-bold text-gray-900" data-id="element-288">{testimonial.name}</p>
                <p className="text-sm text-gray-500" data-id="element-289">
                  {testimonial.age} años • {testimonial.city}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};